import { useEffect, useMemo } from 'react';
import { matchPath, useLocation } from 'react-router-dom';
import ROUTE_IMAGE_PRELOADS from '../../constants/route-image-preloads';

const normalizeImage = (image) => (
  typeof image === 'string'
    ? { href: image, fetchPriority: 'high' }
    : { fetchPriority: 'high', ...image }
);

const hasExistingPreload = ({ href, media }) => {
  const preloads = Array.from(document.querySelectorAll('link[rel="preload"][as="image"]'));
  return preloads.some((link) => link.href === href && (media ? link.media === media
    : !link.media));
};

const RouteImagePreloader = () => {
  const { pathname } = useLocation();

  const imagesToPreload = useMemo(() => {
    const allImages = ROUTE_IMAGE_PRELOADS
      .filter(({ paths }) => paths.some((path) => matchPath(pathname, { path, exact: true })))
      .flatMap(({ images }) => images)
      .map(normalizeImage);

    return allImages;
  }, [pathname]);

  useEffect(() => {
    const linksToCleanup = [];

    imagesToPreload.forEach(({ href, media, fetchPriority }) => {
      if (!href || hasExistingPreload({ href, media })) return;

      const link = document.createElement('link');
      link.rel = 'preload';
      link.as = 'image';
      link.href = href;
      if (media) link.media = media;
      if (fetchPriority) link.setAttribute('fetchpriority', fetchPriority);

      document.head.appendChild(link);
      linksToCleanup.push(link);
    });

    return () => {
      linksToCleanup.forEach((link) => link.remove());
    };
  }, [imagesToPreload]);

  return null;
};

export default RouteImagePreloader;
